// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__2dWDs","header":"styles_header__uZ0KF","back":"styles_back__3Klu7","title":"styles_title__2n0iJ","content":"styles_content__r4PL9"};